import { render, staticRenderFns } from "./observa4.vue?vue&type=template&id=84916bb6&scoped=true"
import script from "./observa4.vue?vue&type=script&lang=js"
export * from "./observa4.vue?vue&type=script&lang=js"
import style0 from "./observa4.vue?vue&type=style&index=0&id=84916bb6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84916bb6",
  null
  
)

export default component.exports